import { CheckoutMetadata, CheckoutSession } from "@/types/checkout/checkout";

export const createCheckoutSession = async (
    priceId: string,
    metadata: CheckoutMetadata
): Promise<CheckoutSession> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/stripe-connect/create-checkout-session`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            priceId,
            metadata
        }),
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return response.json();
}; 